
import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface LinksSectionProps {
  formData: {
    linkedin_url: string;
    website_url: string;
  };
  onInputChange: (field: string, value: string) => void;
}

export default function LinksSection({ formData, onInputChange }: LinksSectionProps) {
  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="linkedin_url">LinkedIn URL</Label>
        <Input
          id="linkedin_url"
          placeholder="https://linkedin.com/in/..."
          value={formData.linkedin_url}
          onChange={(e) => onInputChange('linkedin_url', e.target.value)}
        />
      </div>
      <div>
        <Label htmlFor="website_url">Website URL</Label>
        <Input
          id="website_url"
          placeholder="https://..."
          value={formData.website_url}
          onChange={(e) => onInputChange('website_url', e.target.value)}
        />
      </div>
    </div>
  );
}
